import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=695a1ccd&scoped=true&"
import script from "./statistics.vue?vue&type=script&lang=js&"
export * from "./statistics.vue?vue&type=script&lang=js&"
import style0 from "./statistics.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./statistics.vue?vue&type=style&index=1&id=695a1ccd&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695a1ccd",
  null
  
)

export default component.exports